import { HttpResult } from './API';
export interface FeedAPI extends HttpResult {
    body: {
        data: FeedInstance[],
        message: string,
        status: number,
    }
}

export interface FeedInstance {
    images: string[],
    authorId: number,
    authorPic: string,
    authorName: string,
    brief: string,
    title: string,
    url: string,
    publicTime: number,
    id: number,
    bigCover?: string,
    cover?: string,
    scm?: string,
    backup?: any,
    personalPage?: string,
    duration?: string,
    resourceType?: string,
    pcm?: string,
    type?: string,
    cmt?: number,
    adType?: string,
}

export interface PoliticsFeed {
    title: string,
    url: string,
    isSpecial: boolean,
}

export interface CommentFeed {
    title: string,
    url: string,
    count: number,
}
/**
 * Determine is an object a FeedInstance type.
 * @param  {any} obj
 * @returns objisFeedInstance
 */
export const isFeedInstance = (obj: any): obj is FeedInstance => {
    if (typeof obj === 'object' && obj.images && obj.title && obj.url) {
        return true;
    }
    return false;
};



// WEBPACK FOOTER //
// ./src/models/feed.ts